"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CreateDocs_1 = tslib_1.__importDefault(require("src/modules/debuging/views/CreateDocs"));
const DebugPages_1 = tslib_1.__importDefault(require("src/modules/debuging/views/DebugPages"));
exports.default = [
    {
        isPublic: false,
        path: '/debug',
        element: DebugPages_1.default
    },
    {
        isPublic: false,
        path: '/create-docs',
        element: process.env.NODE_ENV !== 'production' ? CreateDocs_1.default : undefined
    }
];
